import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Development mode - allow access without authentication
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading brand dashboard...
      </div>
    );
  }

  // In development mode, allow access even without authentication
  if (isDevelopment && !user) {
    console.log('Development mode: Allowing access without authentication');
    return children;
  }

  return user ? children : <Navigate to="/signin" replace />;
};

export default PrivateRoute; 